export default {
  address: {
    state: '',
    postalcode: '',
    country: 'Brasil',
    address_number: '',
    address_neighborhood: '',
    address: '',
    city: '',
    address_complement: '',
    autocomplete: false
  },
  ufs: [
    { uf: 'AC', label: 'Acre',                 value: 'Acre' },
    { uf: 'AL', label: 'Alagoas',              value: 'Alagoas' },
    { uf: 'AP', label: 'Amazonas',             value: 'Amazonas' },
    { uf: 'AM', label: 'Amapá',                value: 'Amapá' },
    { uf: 'BA', label: 'Bahia',                value: 'Bahia' },
    { uf: 'CE', label: 'Ceará',                value: 'Ceará' },
    { uf: 'DF', label: 'Distrito Federal',     value: 'Distrito Federal' },
    { uf: 'ES', label: 'Espírito Santo',       value: 'Espírito Santo' },
    { uf: 'GO', label: 'Goiás',                value: 'Goiás' },
    { uf: 'MA', label: 'Maranhão',             value: 'Maranhão' },
    { uf: 'MG', label: 'Minas Gerais',         value: 'Minas Gerais' },
    { uf: 'MT', label: 'Mato Grosso',          value: 'Mato Grosso' },
    { uf: 'MS', label: 'Mato Grosso do Sul',   value: 'Mato Grosso do Sul' },
    { uf: 'PA', label: 'Pará',                 value: 'Pará' },
    { uf: 'PB', label: 'Paraíba',              value: 'Paraíba' },
    { uf: 'PE', label: 'Pernambuco',           value: 'Pernambuco' },
    { uf: 'PI', label: 'Piauí',                value: 'Piauí' },
    { uf: 'PR', label: 'Paraná',               value: 'Paraná' },
    { uf: 'RJ', label: 'Rio de Janeiro',       value: 'Rio de Janeiro' },
    { uf: 'RN', label: 'Rio Grande do Norte',  value: 'Rio Grande do Norte' },
    { uf: 'RO', label: 'Rondônia',             value: 'Rondônia' },
    { uf: 'RR', label: 'Roraima',              value: 'Roraima' },
    { uf: 'RS', label: 'Rio Grande do Sul',    value: 'Rio Grande do Sul' },
    { uf: 'SC', label: 'Santa Catarina',       value: 'Santa Catarina' },
    { uf: 'SE', label: 'Sergipe',              value: 'Sergipe' },
    { uf: 'SP', label: 'São Paulo',            value: 'São Paulo' },
    { uf: 'TO', label: 'Tocantins',            value: 'Tocantins' },
  ],
}